import { type SVGAttributes } from "react";

interface GolfDistrictLightProps extends SVGAttributes<SVGElement> {
    color?: string;
    // Flag path only — defaults to `color` so the 3 existing (translucent,
    // single-tone) usages of this icon are completely unaffected. Only set
    // this when you want the flag to stand out as its own brand accent
    // (e.g. solid, full-opacity usage) instead of matching the ring.
    accentColor?: string;
    // Existing usages rely on the 0.3 default (a soft watermark-style mark on
    // tee-time cards) — kept as the default so nothing else changes.
    fillOpacity?: number;
}

export const GolfDistrictLight = ({
    color,
    accentColor,
    fillOpacity = 0.3,
    ...rest
}: GolfDistrictLightProps) => {
    const fillColor = color ?? "#253748";
    const flagColor = accentColor ?? fillColor;

    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 40 40"
            preserveAspectRatio="xMidYMid meet"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M22.8567 10.1993L11.2559 15.4161C9.6018 16.159 9.57575 18.3919 11.2125 19.1719L21.9102 24.2608H21.9189C25.9696 25.9983 26 28 26 28V12.0896C26 10.5584 24.3198 9.54725 22.8654 10.2035L22.8567 10.1993Z"
                fill={flagColor}
                fillOpacity={fillOpacity}
            />
            <path
                d="M34.8714 33.3646C38.1562 29.7157 40 24.9823 40 20.0009C40 8.61266 30.4323 -0.583142 18.9124 0.0288787C8.77535 0.571175 0.571175 8.77535 0.0288789 18.9124C-0.583141 30.4323 8.61266 40 19.997 40C21.1707 40 22.3483 39.8954 23.4987 39.694C24.3702 39.539 25.0055 38.7837 25.0055 37.9005V31.637C25.0055 31.637 24.9823 28.604 21.3644 26.9771L21.3566 35.1426V36.2969C20.9034 36.3356 20.4502 36.3511 19.997 36.3511C10.5649 36.3511 2.97277 28.3251 3.69325 18.742C4.3014 10.6618 10.6618 4.3014 18.7459 3.69325C28.329 2.97277 36.355 10.5649 36.355 19.997C36.355 23.9751 34.914 27.7673 32.342 30.7229V30.7926V25.2495H28.697V35.007C28.697 36.111 29.5918 37.0057 30.6957 37.0057H40V33.3607H34.5809H34.8714V33.3646Z"
                fill={fillColor}
                fillOpacity={fillOpacity}
            />
        </svg>
    );
};
